import { isWithinN } from '@airreading/common';
import { PlainSessionFeedback } from '@airreading/common/data';

export interface SessionFeedbackStatusProps {
  feedbacks?: Pick<
    PlainSessionFeedback,
    'feedbackSubmitted' | 'lateFeedbackDismissed' | 'submittedAtInstant' | 'submittedHoursFromSessionEnd'
  >[];
  hoursCanceledBeforeStart: number | null;
  lessonShouldSkipFeedback?: boolean | null;
}

export const SessionFeedbackStatus = ({
  feedbacks,
  hoursCanceledBeforeStart,
  lessonShouldSkipFeedback,
}: SessionFeedbackStatusProps) => {
  if (!feedbacks || feedbacks.length === 0) {
    return <>-</>;
  }
  if (lessonShouldSkipFeedback) {
    return '✅ Sent';
  }

  const allSubmitted = feedbacks.length > 0 && feedbacks.every((f) => f.feedbackSubmitted);
  const allLateFeedbacksDismissed = feedbacks.every((f) => f.lateFeedbackDismissed === true);
  const isCanceledWithin12h = isWithinN(hoursCanceledBeforeStart, 12);

  if (allSubmitted || isCanceledWithin12h) {
    let moreThan24H = false;
    const validInstants = feedbacks.flatMap((f) =>
      f.submittedHoursFromSessionEnd ? [f.submittedHoursFromSessionEnd] : [],
    );
    const maxTimeBetweenSubmitAndEnd = Math.max(...validInstants);
    if (maxTimeBetweenSubmitAndEnd >= 24) {
      moreThan24H = true;
    }

    if (allLateFeedbacksDismissed) {
      moreThan24H = false; // If all late feedbacks are dismissed, we don't consider the 24H rule
    }

    return (
      <div className="flex items-center">
        <span>✅ Sent {moreThan24H ? '(> 24H)' : ''}</span>
      </div>
    );
  }

  return <>-</>;
};
